import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=463b8586&scoped=true"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"
import style0 from "./Controls.vue?vue&type=style&index=0&id=463b8586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b8586",
  null
  
)

export default component.exports